// @flow

import React from 'react';
import {Hidden, makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';

import desktopImg from '../../../../../assets/img/minimal/promotions-disabled.png';
import desktopImgMobile from '../../../../../assets/img/minimal/promotions-disabled-mobile.png';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles(theme => ({
  defaultModal: {
    '& .MuiPaper-root': {
      background: '#18003D',
      margin: theme.spacing(4, 4, 0, 4),
    },
  },
  img: {
    width: '100%',
    maxWidth: '100%',
  },
}));

export default function PromotionsDisabledModal({open, handleClose}: Props) {
  const classes = useStyles();
  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.defaultModal}
    >
      <Link to="/tiers-list" className={classes.modal}>
        <Hidden smDown>
          <img src={desktopImg} className={classes.img} alt="" />
        </Hidden>
        <Hidden mdUp>
          <img src={desktopImgMobile} className={classes.img} alt="" />
        </Hidden>
      </Link>
    </CustomModal>
  );
}
